module.exports = __webpack_public_path__ + "static/feature-event2-03e041e5be60dff21c301db9b0294e5e.png";